import React from "react";
import Loader from "./Loader";

export default React.memo(function Avatar({ url, loading, initials }) {
  return (
    <div className="avatar avatar-xxl">
      {loading ? (
        <Loader />
      ) : (
        <>
          {url ? (
            <img src={url} className="avatar-img rounded-circle" />
          ) : (
            <span className="avatar-title rounded-circle">{initials}</span>
          )}
        </>
      )}
    </div>
  );
});
